<template>
  <div>
    <div
      v-if="products == false"
      class="text-xs text-center my-4 text-slate-400 dark:text-slate-500"
    >
      {{ $t("fixed.category.empty") }}
    </div>
    <div v-else>
      <div class="grid-1 my-4">
        <svgApp v-if="mark.length == 1 && mark[0] == type" :type="mark[0]" />
        <p
          :class="`text-sm tracking-wider text-center m-auto uppercase ${
            mark.length == 1 ? 'text-slate-400 dark:text-slate-500' : ''
          }`"
        >
          {{
            mark.length == 1 && mark[0] == type
              ? type + " products"
              : $t("fixed.product.group") + " " + $t(`fixed.category.${type}`)
          }}
        </p>
      </div>
      <div class="grid-2">
        <div v-for="product in products" :key="product.id">
          <div
            class="bg-0 bg-slate-100 h-32 rounded-xl"
            @click="$router.push(`/product/${product.id}`)"
            :style="`background-image: url(${product.images[0]})`"
          ></div>
          <div class="px-4">
            <div dir="auto" class="truncate mt-2">{{ product.name }}</div>
            <div dir="auto" class="start">
              <h1 class="font-medium">{{ product.price }}</h1>
              <h6 class="text-xs mx-2">DZD</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import svgApp from "@/components/svgApp.vue";
import { db } from "@/assets/db";

export default {
  components: { svgApp },
  data() {
    return {
      type: this.$route.params.type,
      products: [],
      mark: [],
    };
  },
  async created() {
    const products = await db.products
      .where("category")
      .equals(this.type)
      .toArray();
    this.products = products.length ? products : false;
    this.mark = [...new Set(products.map((product) => product.mark))];
  },
};
</script>
